import { useAppSelector } from "../store/hooks/hooks";
import HydratesCalculator from "./Hydrates/Hydrates";
import IPRCalculator from "./IPR/IPR";
import PvtCalculator from "./Pvt/Pvt";
import WaterContentCalculator from "./WaterContent/WaterContent";
import VLPCalculator from "./Vlp/VLP";
import GasRateCriticalCalculator from "./GasRateCritical/GasRateCritical";
import SystemPlot from "./SystemPlot/SystemPlot";
import './ActiveCalculator.css';
import PressureDropCalculator from "./PressureDrop/PressureDrop";
import MaterialBalance from "./MaterialBalance/MaterialBalance";

const ActiveCalculator: React.FC = () => {
	const activeCalc = useAppSelector(state => state.app.activeSubCategory);

	return <div className="active-calculator">
		{activeCalc === "gas_pvt" && <PvtCalculator />}
		{activeCalc === "water_content" && <WaterContentCalculator />}
		{activeCalc === "hydrates" && <HydratesCalculator />}
		{activeCalc === "ipr" && <IPRCalculator />}
		{activeCalc === "vlp" && <VLPCalculator />}
		{activeCalc === "gas_rate_critical" && <GasRateCriticalCalculator />}
		{activeCalc === "system_plot" && <SystemPlot />}
		{activeCalc === "pressure_drop" && <PressureDropCalculator />}
		{activeCalc === "material_balance" && <MaterialBalance />}
	</div>
}

export default ActiveCalculator;